<div class="question-wrapper-star vertical-view-radio" *ngIf="displayMode == 'Vertical'">
  <div class="div-content sentence-align">
    <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
  </div>

  <div class="example-margin example-margin2 vertical">
    <div class="stars-block" [ngClass]="questions?.questionsdisplayoptions == 'Horizontal' ? '': 'vertical-view d-block'">
      <span class="stars" *ngFor="let item of [].constructor(numberOfStar)"><mat-icon>star_border</mat-icon></span>
    </div>
    <div class="vertical-progress">
      <span>{{questions.ratinglow}}</span>
      <span>{{questions.ratinghigh}}</span>
    </div>
  </div>
</div>

<div class="question-wrapper-star horizontal-view-radio" *ngIf="displayMode == 'Horizontal'">
  <div class="col-w-40">
    <div class="div-content">
      <ng-component class="editor-question"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
    </div>
  </div>
  <div class="col-w-60">
    <div class="example-margin example-margin2 horizontal">
      <div class="stars-block">
        <span class="stars-1" *ngFor="let item of [].constructor(numberOfStar)"><mat-icon>star_border</mat-icon></span>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <span class="horizontal-wrap">{{questions.ratinglow}}</span>
        <span class="horizontal-wrap">{{questions.ratinghigh}}</span>
      </div>
    </div>
  </div>
</div>
